import { Modal, List, Tag, Button, Empty } from "antd";
import { Bell, AlertTriangle, CheckCircle } from "lucide-react";
import dayjs from "dayjs";

const STATUS_LABELS = {
  PENDING: "Pendiente",
  IN_PROGRESS: "En Progreso",
};

const PRIORITY_COLORS = {
  LOW: "green",
  MEDIUM: "orange",
  HIGH: "red",
};

function TaskRemindersModal({ visible, reminders, onClose, onViewTask, onMarkComplete }) {
  const today = dayjs().startOf("day");

  const overdueReminders = reminders.filter(
    (r) => r.date && dayjs(r.date).isBefore(today)
  );
  const todayReminders = reminders.filter(
    (r) => r.date && dayjs(r.date).isSame(today, "day")
  );

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <Bell size={20} className="text-orange-500" />
          <span>Recordatorios pendientes</span>
          {reminders.length > 0 && (
            <Tag color="red">{reminders.length}</Tag>
          )}
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={
        <Button type="primary" onClick={onClose}>
          Entendido
        </Button>
      }
      width={550}
    >
      {reminders.length === 0 ? (
        <Empty
          image={<CheckCircle size={48} className="text-green-500 mx-auto" />}
          description="No tienes recordatorios pendientes"
        />
      ) : (
        <>
          {/* Tareas vencidas */}
          {overdueReminders.length > 0 && (
            <div className="mb-4">
              <h4 className="font-semibold text-red-500 mb-2 flex items-center gap-2">
                <AlertTriangle size={16} />
                Vencidas ({overdueReminders.length})
              </h4>
              <List
                size="small"
                dataSource={overdueReminders}
                renderItem={(task) => (
                  <List.Item
                    className="cursor-pointer hover:bg-gray-50"
                    onClick={() => {
                      onClose();
                      onViewTask(task);
                    }}
                    actions={[
                      <Button
                        key="complete"
                        size="small"
                        type="link"
                        onClick={(e) => {
                          e.stopPropagation();
                          onMarkComplete(task.id);
                        }}
                      >
                        Completar
                      </Button>,
                    ]}
                  >
                    <List.Item.Meta
                      avatar={
                        <span
                          className="w-3 h-3 rounded-full inline-block mt-1"
                          style={{ backgroundColor: task.color }}
                        />
                      }
                      title={task.title}
                      description={
                        <div className="flex items-center gap-2">
                          <span className="text-red-500">
                            Vencida: {dayjs(task.date).format("DD/MM/YYYY")}
                          </span>
                          <Tag color={PRIORITY_COLORS[task.priority]} className="m-0">
                            {task.priority}
                          </Tag>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
          )}

          {/* Tareas de hoy */}
          {todayReminders.length > 0 && (
            <div>
              <h4 className="font-semibold text-orange-500 mb-2 flex items-center gap-2">
                <Bell size={16} />
                Para hoy ({todayReminders.length})
              </h4>
              <List
                size="small"
                dataSource={todayReminders}
                renderItem={(task) => (
                  <List.Item
                    className="cursor-pointer hover:bg-gray-50"
                    onClick={() => {
                      onClose();
                      onViewTask(task);
                    }}
                    actions={[
                      <Button
                        key="complete"
                        size="small"
                        type="link"
                        onClick={(e) => {
                          e.stopPropagation();
                          onMarkComplete(task.id);
                        }}
                      >
                        Completar
                      </Button>,
                    ]}
                  >
                    <List.Item.Meta
                      avatar={
                        <span
                          className="w-3 h-3 rounded-full inline-block mt-1"
                          style={{ backgroundColor: task.color }}
                        />
                      }
                      title={task.title}
                      description={
                        <div className="flex items-center gap-2">
                          <span>{STATUS_LABELS[task.status]}</span>
                          <Tag color={PRIORITY_COLORS[task.priority]} className="m-0">
                            {task.priority}
                          </Tag>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
          )}
        </>
      )}
    </Modal>
  );
}

export default TaskRemindersModal;
